import { FC, useState } from "react";
import AddCard from "../AddCard";
import MenstruationDialog from "./MenstruationDialog";
import { DateTime } from "luxon";

interface AddMenstruationCardProps {
  addMenstruation: (newMenstruation: {
    startDate: DateTime;
    endDate: DateTime;
  }) => void;
}

const AddMenstruationCard: FC<AddMenstruationCardProps> = ({
  addMenstruation,
}) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <AddCard onClick={handleOpen} />
      <MenstruationDialog
        addMenstruation={addMenstruation}
        handleClose={handleClose}
        open={open}
        variant="add"
      />
    </>
  );
};

export default AddMenstruationCard;
